/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServerResponseModel } from 'app/shared/models/serverResponse.model';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class SportsService {
  constructor(private httpClient: HttpClient) {}

  getAllSports(): Observable<any> {
    return this.httpClient
      .get(`${environment.apiHostname}/v1/sports?skip=0&take=0`)
      .pipe(map(this.handleServerResponse));
  }

  getSportIdsByUrlPath(sportUrlPath: string): Observable<any> {
    return this.httpClient.get(`${environment.apiHostname}/v1/sports?skip=0&take=0`).pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data.sports.filter((sport) => this.getSportSlug(sport.name) === sportUrlPath);
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }

  getSportSlug(sportName): string {
    if (!sportName) {
      return sportName;
    }
    return sportName.toLowerCase().split(' ').join('-');
  }

  getSportImg(sportName: string): string {
    return sportName.toLowerCase().split(' ').join('');
  }

  getSportName(sportName: string): string {
    if (!sportName) {
      return '';
    }
    return sportName.toLowerCase().replace('-', ' ');
  }

  getRelatedSports(sportName: string, sports) {
    const sportSlug = this.getSportSlug(sportName).replace('-', ' ');
    return sports.filter((s) => s.name.toLowerCase().includes(sportSlug));
  }

  getSportNameById(sportId: number, sports: any[]) {
    if (sportId === null || sportId === undefined || !Array.isArray(sports)) {
      return;
    }
    const selectedSport = sports.find((sport) => sport.id === sportId);
    return selectedSport ? selectedSport.name : null;
  }

  private handleServerResponse = (response: ServerResponseModel) => {
    if (response.result.success) {
      return response.data;
    } else {
      throw new Error(response.result.message);
    }
  };
}
